import {yupResolver} from "@hookform/resolvers/yup";
import classNames from "classnames";
import {FormProvider, useForm} from "react-hook-form";
import * as Yup from "yup";

import {Alert} from "@/components/alert/Alert.tsx";
import {Button} from "@/components/button/Button.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {SelectionCard} from "@/components/selectionCard/SelectionCard.tsx";
import {AnalyzerPhase, AnalyzerPollCardProps, InterviewFormValues} from "@/pages/analyzer/Analyzer.types.ts";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerPollCard.module.scss";

const PollSchema = Yup.object().shape({
  answer: Yup.string().required("Please select an option"),
});

export const AnalyzerPollCard = ({event, mode = "initial", className}: AnalyzerPollCardProps) => {
  const {answers, handleAnswer, cancelPollEdit, phase} = useAnalyzerContext();
  const isStreaming = phase === AnalyzerPhase.STREAMING;
  const currentAnswer = (event.checkpoint_id && answers[event.checkpoint_id]) || "";
  const methods = useForm<InterviewFormValues>({
    resolver: yupResolver<InterviewFormValues>(PollSchema),
    defaultValues: {answer: mode === "edit" ? currentAnswer : ""},
  });
  const selected = methods.watch("answer");
  const error = methods.formState.errors.answer?.message;

  const onSubmit = methods.handleSubmit(({answer}) => handleAnswer(answer, event));

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit} className={classNames(styles.pollCard, className)}>
        <div className={styles.question}>{event.question}</div>
        <SelectionCard
          aria-label={event.question}
          layout="vertical"
          variant="compact"
          value={selected}
          onChange={(value) => methods.setValue("answer", value, {shouldValidate: true})}
        >
          {event.options.map((option) => (
            <SelectionCard.Option
              key={option.label}
              value={option.label}
              title={option.label}
              description={option.description}
              labelPosition="right"
              radioVariant="cloudStatus"
            />
          ))}
        </SelectionCard>
        <FormSubtext error={error} />
        {mode === "edit" && (
          <Alert variant="maintenance" callout="Warning">
            Applying a new {event.topic.toLowerCase() || "answer"} replaces your current proposed Checks.
          </Alert>
        )}
        <div className={styles.actions}>
          {mode === "edit" && (
            <Button variant="secondary" size="small" onClick={cancelPollEdit} disabled={isStreaming}>
              Cancel
            </Button>
          )}
          <Button type="submit" variant="primary" size="small" disabled={isStreaming}>
            {mode === "edit" ? "Apply Changes" : "Apply + Propose Checks"}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
